<div class="hc" *ngIf="empresa">

  <!-- Loja recebendo pedido com o caixa fechado: aviso no topo, não linha neutra em "Agora na loja". -->
  <button type="button" class="hc-som" *ngIf="momento === 'aberta' && exibirCaixa && !caixa.aberto" (click)="abraRota('/admin/meupdv')">
    <i class="fe-inbox" aria-hidden="true"></i>
    <span class="hc-linha__txt"><b>Caixa fechado</b><span>Abra o caixa para registrar os pagamentos de hoje.</span></span>
  </button>

  <ng-container [ngSwitch]="momento">

    <!-- ═══════════ Conta nova: cardápio no ar, nenhum pedido ainda ═══════════ -->
    <ng-container *ngSwitchCase="'contaNova'">
      <section class="hc-bloco hc-vitrine" *ngIf="linkCardapio">
        <div class="hc-vitrine__topo">
          <span class="hc-vitrine__logo">
            <img *ngIf="empresa.logo" [src]="'/images/empresa/' + empresa.logo" alt="">
            <span *ngIf="!empresa.logo">{{(empresa.nome || 'L').charAt(0)}}</span>
          </span>
          <div>
            <h2>Sua loja está no ar</h2>
            <button type="button" class="hc-link" (click)="abraLoja()"><i class="fe-link" aria-hidden="true"></i>{{linkCurto}}</button>
          </div>
        </div>
        <div class="hc-vitrine__acoes">
          <button type="button" class="hc-btn hc-btn--zap" (click)="compartilhe()"><i class="fe-send" aria-hidden="true"></i>Mandar para os clientes</button>
          <button type="button" class="hc-btn hc-btn--sec hc-btn--quadrado" (click)="copieLink()" aria-label="Copiar link"><i class="fe-copy" aria-hidden="true"></i></button>
          <button type="button" class="hc-btn hc-btn--sec hc-btn--quadrado" (click)="folha = 'qr'" aria-label="Ver QR Code"><i class="fas fa-qrcode" aria-hidden="true"></i></button>
        </div>
      </section>

      <div class="hc-secao"><h2>Para o primeiro pedido chegar</h2></div>
      <section class="hc-bloco">
        <button type="button" class="hc-linha" (click)="abraLoja()">
          <span class="hc-pastel hc-p-azul"><i class="fe-shopping-cart" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>Faça um pedido de teste</b><span>Veja como ele chega e o celular toca.</span></span>
          <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="hc-linha" (click)="compartilhe()">
          <span class="hc-pastel hc-p-verde"><i class="fe-send" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>Mande o link no WhatsApp</b><span>Para seus contatos e no status de hoje.</span></span>
          <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="hc-linha" (click)="copieLink('Link copiado. Cole na bio do Instagram.')">
          <span class="hc-pastel hc-p-rosa"><i class="fe-instagram" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>Ponha o link na bio do Instagram</b><span>Quem vê o perfil pede sem precisar chamar.</span></span>
          <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="hc-linha" (click)="folha = 'qr'">
          <span class="hc-pastel hc-p-ambar"><i class="fas fa-qrcode" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>Imprima o QR Code</b><span>No balcão, nas mesas e na sacola de entrega.</span></span>
          <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
        </button>
      </section>

      <ng-container *ngIf="portasDeVenda.length">
        <div class="hc-secao"><h2>Vendeu fora do cardápio?</h2></div>
        <ng-container *ngTemplateOutlet="tplVender"></ng-container>
      </ng-container>
    </ng-container>

    <!-- ═══════════ Antes de abrir ═══════════ -->
    <ng-container *ngSwitchCase="'antes'">
      <section class="hc-bloco hc-relogio">
        <svg class="hc-anel" viewBox="0 0 54 54" aria-hidden="true">
          <circle cx="27" cy="27" r="23" fill="none" class="hc-anel__fundo" stroke-width="6"/>
          <circle cx="27" cy="27" r="23" fill="none" class="hc-anel__frente" stroke-width="6" stroke-linecap="round"
                  stroke-dasharray="144.5" [attr.stroke-dashoffset]="144.5 * (1 - progressoAbertura)" transform="rotate(-90 27 27)"/>
        </svg>
        <div>
          <div class="hc-relogio__h">Abre às {{proximaAbertura}}</div>
          <div class="hc-relogio__s">{{faltaParaAbrir}}. A loja abre sozinha no horário.</div>
        </div>
      </section>
      <ng-container *ngTemplateOutlet="tplLink"></ng-container>

      <ng-container *ngIf="exibirCaixa && !caixa.aberto">
        <div class="hc-secao"><h2>Deixe pronto</h2></div>
        <section class="hc-bloco">
          <button type="button" class="hc-linha" (click)="abraRota('/admin/meupdv')">
            <span class="hc-pastel hc-p-teal"><i class="fe-inbox" aria-hidden="true"></i></span>
            <span class="hc-linha__txt"><b>Abra o caixa</b><span>Informe o troco que está na gaveta.</span></span>
            <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
          </button>
        </section>
      </ng-container>

      <ng-container *ngTemplateOutlet="tplAgendados"></ng-container>
    </ng-container>

    <!-- ═══════════ Aberta (ou pausada) ═══════════ -->
    <ng-container *ngSwitchCase="'aberta'">
      <ng-container *ngTemplateOutlet="tplHoje"></ng-container>
      <ng-container *ngTemplateOutlet="tplLink"></ng-container>

      <ng-container *ngIf="temModuloPedidos">
        <div class="hc-secao">
          <h2>Pedidos agora <small *ngIf="comandas.length">{{comandas.length}}</small></h2>
          <button type="button" (click)="abraRota('/admin/pedidos')">Ver lista</button>
        </div>

        <ng-container *ngIf="comandas.length; else tplTudoCerto">
          <div class="hc-abas" *ngIf="abas.length" role="tablist" aria-label="Filtrar pedidos por etapa">
            <button type="button" class="hc-aba" *ngFor="let aba of abas" role="tab" [attr.aria-selected]="abaAtual === aba.id"
                    [class.on]="abaAtual === aba.id" (click)="escolhaAba(aba.id)">
              {{aba.nome}} <b>{{aba.total}}</b>
            </button>
          </div>

          <div class="hc-lista">
            <article class="hc-comanda" *ngFor="let comanda of comandasNaLista; trackBy: identifiqueComanda"
                     [ngClass]="'hc-comanda--' + comanda.tom" [class.hc-comanda--ocupada]="estaProcessando(comanda)">
              <button type="button" class="hc-comanda__cima" (click)="abraComanda(comanda)" [attr.aria-label]="'Abrir ' + comanda.titulo + ' ' + comanda.meta">
                <span class="hc-comanda__meta">
                  <span class="hc-chip"><i [class]="comanda.icone" aria-hidden="true"></i>{{comanda.rotulo}}</span>
                  <span class="hc-comanda__codigo">{{comanda.meta}}</span>
                  <span class="hc-comanda__tempo" [class.hc-comanda__tempo--quente]="comanda.quente" *ngIf="comanda.tempo">
                    <i class="fe-clock" aria-hidden="true"></i>{{comanda.tempo}}
                  </span>
                </span>
                <span class="hc-comanda__quem">
                  <b>{{comanda.titulo}}</b>
                  <span *ngIf="comanda.valor !== null">{{moeda(comanda.valor)}}</span>
                </span>
                <span class="hc-comanda__itens" *ngIf="comanda.itens.length">
                  <span class="hc-comanda__item" *ngFor="let item of comanda.itens">
                    <em>{{item.qtde}}</em><span>{{item.descricao}}<small *ngIf="item.observacao">{{item.observacao}}</small></span>
                  </span>
                  <span class="hc-comanda__mais" *ngIf="comanda.maisItens">+ {{comanda.maisItens}} {{comanda.maisItens === 1 ? 'item' : 'itens'}}</span>
                </span>
                <span class="hc-comanda__nota">{{comanda.nota}}</span>
              </button>
              <div class="hc-picote" aria-hidden="true"></div>
              <div class="hc-comanda__acoes">
                <button type="button" class="hc-btn" *ngIf="comanda.passo; else semPasso"
                        [ngClass]="comanda.passo.tipo === 'aceitar' || comanda.passo.status === 'Em preparação' ? 'hc-btn--pri' : 'hc-btn--verde'"
                        [disabled]="estaProcessando(comanda)" (click)="executePasso(comanda)">
                  <i [class]="estaProcessando(comanda) ? 'fe-loader hc-girando' : comanda.passo.icone" aria-hidden="true"></i>{{comanda.passo.texto}}
                </button>
                <ng-template #semPasso>
                  <button type="button" class="hc-btn hc-btn--pri" (click)="abraComanda(comanda)">
                    {{comanda.pedido ? 'Ver pedido' : 'Resolver'}}<i class="fe-arrow-right" aria-hidden="true"></i>
                  </button>
                </ng-template>
                <button type="button" class="hc-btn hc-btn--sec hc-btn--quadrado" *ngIf="comanda.pedido"
                        [disabled]="estaProcessando(comanda)" (click)="abraMais(comanda)" aria-label="Mais ações do pedido">
                  <i class="fe-more-horizontal" aria-hidden="true"></i>
                </button>
              </div>
            </article>
          </div>
          <button type="button" class="hc-ver-mais" *ngIf="comandasForaDaLista" (click)="vejaMaisComandas()">
            Ver mais {{comandasForaDaLista}} {{comandasForaDaLista === 1 ? 'pedido' : 'pedidos'}}<i class="fe-chevron-down" aria-hidden="true"></i>
          </button>
        </ng-container>

        <section class="hc-bloco hc-antigos" *ngIf="pedidosAntigos.total">
          <button type="button" class="hc-linha" (click)="abraRota('/admin/pedidos')">
            <span class="hc-pastel hc-p-cinza"><i class="fe-archive" aria-hidden="true"></i></span>
            <span class="hc-linha__txt">
              <b>{{pedidosAntigos.total}} {{pedidosAntigos.total === 1 ? 'pedido antigo' : 'pedidos antigos'}} sem finalizar</b>
              <span>O mais antigo está aberto há {{pedidosAntigos.maisAntigo}}. Finalize ou cancele na lista.</span>
            </span>
            <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
          </button>
        </section>

        <ng-template #tplTudoCerto>
          <section class="hc-bloco hc-tudo-certo">
            <span class="hc-pastel hc-p-verde"><i class="fe-check" aria-hidden="true"></i></span>
            <span><b>Nenhum pedido agora</b><span>O próximo pedido toca e aparece aqui.</span></span>
          </section>
        </ng-template>
      </ng-container>

      <ng-container *ngTemplateOutlet="tplAgoraNaLoja"></ng-container>
    </ng-container>

    <!-- ═══════════ Fechada, sem abertura hoje ═══════════ -->
    <ng-container *ngSwitchCase="'fechou'">
      <section class="hc-bloco hc-dia" *ngIf="exibirHoje && pedidosHoje">
        <button type="button" class="hc-dia__corpo" (click)="abraRelatorioVendas()">
          <span class="hc-rotulo">Seu dia</span>
          <span class="hc-valor"><small>R$</small>{{valorSemSimbolo(totalHoje)}}</span>
          <span class="hc-detalhe" *ngIf="variacaoHoje as variacao">
            <span [class.hc-sobe]="variacao.sobe" [class.hc-desce]="!variacao.sobe">{{variacao.texto}}</span> que {{diaComparado}}
          </span>
          <span class="hc-horas" *ngIf="barrasHoras.length">
            <span class="hc-horas__barra" *ngFor="let barra of barrasHoras" [class.hc-horas__barra--melhor]="barra.melhor"
                  [style.height.%]="barra.altura"></span>
          </span>
          <span class="hc-horas-rotulo" *ngIf="barrasHoras.length">
            <span *ngFor="let barra of barrasHoras">{{barra.rotulo}}</span>
          </span>
          <span class="hc-trio">
            <span><b>{{pedidosHoje}}</b>pedidos</span>
            <span><b>{{moeda(ticketHoje)}}</b>ticket médio</span>
            <span><b>{{moeda(taxasHoje)}}</b>de taxas</span>
          </span>
        </button>
      </section>
      <ng-container *ngTemplateOutlet="tplLink"></ng-container>

      <ng-container *ngIf="exibirCaixa && caixa.aberto">
        <div class="hc-secao"><h2>Fechar o caixa</h2></div>
        <section class="hc-bloco">
          <button type="button" class="hc-linha" (click)="abraRota('/admin/meupdv')">
            <span class="hc-pastel hc-p-teal"><i class="fe-inbox" aria-hidden="true"></i></span>
            <span class="hc-linha__txt"><b>Confira a gaveta e feche o caixa</b><span>Aberto desde {{caixa.desde}}{{caixa.operador ? ' por ' + caixa.operador : ''}}.</span></span>
            <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
          </button>
        </section>
      </ng-container>

      <div class="hc-secao"><h2>Próxima abertura</h2></div>
      <section class="hc-bloco">
        <button type="button" class="hc-linha" (click)="podeGerenciarLoja ? abraRota('/admin/loja/tab/horarios') : null">
          <span class="hc-pastel hc-p-cinza"><i class="fe-sun" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>{{textoEstadoLoja}}</b><span *ngIf="podeGerenciarLoja">Ver os horários da semana</span></span>
          <i class="fe-chevron-right hc-seta" aria-hidden="true" *ngIf="podeGerenciarLoja"></i>
        </button>
      </section>

      <ng-container *ngTemplateOutlet="tplAgendados"></ng-container>
    </ng-container>
  </ng-container>

  <!-- ═══════════ Comum a todos os momentos ═══════════ -->
  <ng-container *ngIf="atalhos.length">
    <div class="hc-secao"><h2>Seus atalhos</h2></div>
    <section class="hc-bloco hc-atalhos">
      <button type="button" class="hc-atalho" *ngFor="let funcao of atalhos" (click)="execute(funcao)">
        <span class="hc-pastel" [ngClass]="'hc-p-' + corDaFuncao(funcao)"><i [class]="iconeDaFuncao(funcao.icone)" aria-hidden="true"></i></span>
        {{funcao.nome}}
      </button>
    </section>
  </ng-container>

  <button type="button" class="hc-home-completa" (click)="verHomeCompletaAgora()">Ver a página inicial completa</button>


  <!-- ═══════════ Blocos reaproveitados ═══════════ -->

  <ng-template #tplLink>
    <!-- O link do cardápio à vista: é o que o dono mais manda no WhatsApp. Tocar no link copia. -->
    <section class="hc-bloco hc-meu-link" *ngIf="linkCardapio">
      <button type="button" class="hc-meu-link__texto" (click)="copieLink()" aria-label="Copiar o link do cardápio">
        <i class="fe-link" aria-hidden="true"></i>
        <span><small>Seu cardápio</small>{{linkCurto}}</span>
      </button>
      <button type="button" class="hc-meu-link__btn hc-meu-link__btn--enviar" (click)="compartilhe()"><i class="fe-send" aria-hidden="true"></i>Enviar</button>
      <div class="hc-meu-link__acoes">
        <button type="button" (click)="copieLink()"><i class="fe-copy" aria-hidden="true"></i>Copiar</button>
        <button type="button" (click)="abraLoja()"><i class="fe-external-link" aria-hidden="true"></i>Abrir</button>
        <button type="button" (click)="folha = 'qr'"><i class="fas fa-qrcode" aria-hidden="true"></i>QR Code</button>
      </div>
    </section>
  </ng-template>

  <ng-template #tplHoje>
    <section class="hc-bloco hc-hoje" *ngIf="exibirHoje">
      <button type="button" class="hc-hoje__corpo" (click)="abraRelatorioVendas()">
        <span class="hc-hoje__txt">
          <span class="hc-valor"><small>R$</small>{{valorSemSimbolo(totalHoje)}}</span>
          <span class="hc-detalhe">{{pedidosHoje}} {{pedidosHoje === 1 ? 'pedido' : 'pedidos'}} hoje</span>
          <span class="hc-detalhe" *ngIf="variacaoHoje as variacao">
            <span [class.hc-sobe]="variacao.sobe" [class.hc-desce]="!variacao.sobe">{{variacao.texto}}</span> que {{diaComparado}}
          </span>
        </span>
        <span class="hc-mini" *ngIf="barrasHoras.length" aria-hidden="true">
          <span *ngFor="let barra of barrasHoras" [class.melhor]="barra.melhor" [style.height.%]="barra.altura"></span>
        </span>
      </button>
    </section>
  </ng-template>

  <ng-template #tplVender>
    <section class="hc-bloco hc-vender">
      <button type="button" class="hc-porta" *ngFor="let porta of portasDeVenda" (click)="execute(porta.funcao)">
        <span class="hc-pastel" [ngClass]="'hc-p-' + porta.cor"><i [class]="porta.icone" aria-hidden="true"></i></span>
        <b>{{porta.nome}}</b><small>{{porta.detalhe}}</small>
      </button>
    </section>
  </ng-template>

  <ng-template #tplAgoraNaLoja>
    <div class="hc-secao"><h2>Agora na loja</h2></div>
    <section class="hc-bloco">
      <div class="hc-linha">
        <span class="hc-pastel" [ngClass]="estadoLoja === 'pausada' ? 'hc-p-ambar' : 'hc-p-verde'">
          <i [class]="estadoLoja === 'pausada' ? 'fe-pause' : 'fe-radio'" aria-hidden="true"></i>
        </span>
        <span class="hc-linha__txt"><b>{{estadoLoja === 'pausada' ? 'Loja pausada' : 'Loja aberta'}}</b><span>{{textoEstadoLoja}}</span></span>
        <ng-container *ngIf="podeGerenciarLoja">
          <button type="button" class="hc-mini-btn" *ngIf="estadoLoja === 'aberta'" (click)="pausarLoja()">Pausar</button>
          <button type="button" class="hc-mini-btn hc-mini-btn--pri" *ngIf="estadoLoja === 'pausada'" [disabled]="reabrindo" (click)="reabrirLoja()">
            {{reabrindo ? 'Reabrindo…' : 'Reabrir'}}
          </button>
        </ng-container>
      </div>
      <button type="button" class="hc-linha" *ngIf="exibirMesas" (click)="abraRota('/admin/pedidos-mesas')">
        <span class="hc-pastel hc-p-roxo"><i class="fe-grid" aria-hidden="true"></i></span>
        <span class="hc-linha__txt"><b>Mesas</b><span>{{mesas.ocupadas}} de {{mesas.total}} ocupadas</span></span>
        <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
      </button>
      <button type="button" class="hc-linha" *ngIf="exibirCaixa && caixa.aberto" (click)="abraRota('/admin/meupdv')">
        <span class="hc-pastel hc-p-teal"><i class="fe-inbox" aria-hidden="true"></i></span>
        <span class="hc-linha__txt">
          <b>Caixa aberto desde {{caixa.desde}}</b>
          <span>{{caixa.operador ? 'Aberto por ' + caixa.operador : 'Em operação'}}</span>
        </span>
        <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
      </button>
    </section>
  </ng-template>

  <ng-template #tplAgendados>
    <ng-container *ngIf="temModuloPedidos && agendados.length">
      <div class="hc-secao"><h2>Marcados para hoje</h2></div>
      <section class="hc-bloco">
        <button type="button" class="hc-linha" *ngFor="let pedido of agendados"
                (click)="abraRota('/admin/pedidos/detalhes/' + pedido.guid + '?t=' + pedido.id)">
          <span class="hc-pastel hc-p-roxo"><i class="fe-calendar" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>{{clienteAgendado(pedido)}}, às {{hora(pedido.horarioEntregaAgendada)}}</b><span>#{{pedido.codigo}}{{pedido.formaDeEntrega ? ', ' + pedido.formaDeEntrega : ''}}</span></span>
          <span class="hc-linha__dir">{{moeda(pedido.total)}}</span>
        </button>
      </section>
    </ng-container>
  </ng-template>

  <!-- ═══════════ Folhas que sobem de baixo ═══════════ -->

  <div class="hc-veu" *ngIf="folha" (click)="fecheFolha()" aria-hidden="true"></div>

  <div class="hc-folha" *ngIf="folha === 'qr'" role="dialog" aria-modal="true" aria-label="QR Code do cardápio">
    <div class="hc-puxador" aria-hidden="true"></div>
    <div class="hc-folha__topo">
      <h3>QR Code do cardápio</h3>
      <button type="button" class="hc-fechar" (click)="fecheFolha()" aria-label="Fechar"><i class="fe-x" aria-hidden="true"></i></button>
    </div>
    <p class="hc-folha__texto">O cliente aponta a câmera e abre o cardápio. Cole no balcão, nas mesas e na sacola.</p>
    <div class="hc-qr">
      <img src="/qrcode/qrcodeloja" alt="QR Code do cardápio" *ngIf="!qrErro" (error)="qrErro = true">
      <i class="fas fa-qrcode" *ngIf="qrErro" aria-hidden="true"></i>
    </div>
    <div class="hc-folha__acoes">
      <a class="hc-btn hc-btn--sec" href="/qrcode/qrcodeloja" download="qrcode-cardapio.png"><i class="fe-download" aria-hidden="true"></i>Salvar</a>
      <button type="button" class="hc-btn hc-btn--pri" (click)="compartilhe()"><i class="fe-share-2" aria-hidden="true"></i>Compartilhar link</button>
    </div>
  </div>

  <div class="hc-folha" *ngIf="folha === 'mais' && pedidoEmAcao" role="dialog" aria-modal="true" aria-label="Mais ações do pedido">
    <div class="hc-puxador" aria-hidden="true"></div>
    <div class="hc-folha__topo">
      <h3>Pedido #{{pedidoEmAcao.codigo}}</h3>
      <button type="button" class="hc-fechar" (click)="fecheFolha()" aria-label="Fechar"><i class="fe-x" aria-hidden="true"></i></button>
    </div>

    <ng-container *ngIf="statusDaFolhaMais.length">
      <p class="hc-folha__texto">Mudar para</p>
      <section class="hc-bloco">
        <button type="button" class="hc-linha" *ngFor="let status of statusDaFolhaMais" (click)="vaParaStatus(pedidoEmAcao, status)">
          <span class="hc-glifo"><i class="fe-arrow-right-circle" aria-hidden="true"></i></span>
          <span class="hc-linha__txt"><b>{{status}}</b></span>
        </button>
      </section>
    </ng-container>

    <section class="hc-bloco">
      <button type="button" class="hc-linha hc-linha--perigo" *ngIf="podeRecusarAqui" (click)="recuse()">
        <span class="hc-glifo"><i class="fe-x-circle" aria-hidden="true"></i></span>
        <span class="hc-linha__txt">
          <b>{{pedidoEmAcao.origemExterna ? 'Recusar no pedido' : (confirmandoRecusa ? 'Toque de novo para recusar' : 'Recusar pedido')}}</b>
          <span *ngIf="pedidoEmAcao.origemExterna">A plataforma pede o motivo; abre o pedido completo.</span>
          <span *ngIf="!pedidoEmAcao.origemExterna && confirmandoRecusa">O cliente é avisado e o pedido sai da fila.</span>
        </span>
      </button>
      <button type="button" class="hc-linha" (click)="abraPedidoEmAcao()">
        <span class="hc-glifo"><i class="fe-file-text" aria-hidden="true"></i></span>
        <span class="hc-linha__txt"><b>Abrir pedido completo</b><span>Editar, cancelar, imprimir de novo</span></span>
        <i class="fe-chevron-right hc-seta" aria-hidden="true"></i>
      </button>
    </section>
  </div>

  <div class="hc-folha" *ngIf="folha === 'entregador' && pedidoEmAcao" role="dialog" aria-modal="true" aria-label="Escolher entregador">
    <div class="hc-puxador" aria-hidden="true"></div>
    <div class="hc-folha__topo">
      <h3>Quem vai levar?</h3>
      <button type="button" class="hc-fechar" (click)="fecheFolha()" aria-label="Fechar"><i class="fe-x" aria-hidden="true"></i></button>
    </div>
    <p class="hc-folha__texto">Pedido #{{pedidoEmAcao.codigo}} sai para entrega.</p>
    <section class="hc-bloco">
      <button type="button" class="hc-linha" *ngFor="let entregador of entregadores" (click)="escolhaEntregador(entregador)">
        <span class="hc-pastel hc-p-ambar"><i class="fe-navigation" aria-hidden="true"></i></span>
        <span class="hc-linha__txt"><b>{{entregador.nome}}</b></span>
      </button>
      <button type="button" class="hc-linha" (click)="escolhaEntregador(null)">
        <span class="hc-pastel hc-p-cinza"><i class="fe-minus" aria-hidden="true"></i></span>
        <span class="hc-linha__txt"><b>Sem entregador</b></span>
      </button>
    </section>
  </div>

  <div class="hc-folha" *ngIf="folha === 'pagamento' && pedidoEmAcao" role="dialog" aria-modal="true" aria-label="Pagamento do pedido">
    <div class="hc-puxador" aria-hidden="true"></div>
    <div class="hc-folha__topo">
      <h3>{{escolhendoFormaDoSaldo ? 'Como recebeu o saldo?' : textoPagamento}}</h3>
      <button type="button" class="hc-fechar" (click)="fecheFolha()" aria-label="Fechar"><i class="fe-x" aria-hidden="true"></i></button>
    </div>
    <p class="hc-folha__texto">Pedido #{{pedidoEmAcao.codigo}}{{statusEmAcao ? ' vai como entregue.' : '.'}}</p>

    <div class="hc-folha__acoes" *ngIf="!escolhendoFormaDoSaldo">
      <button type="button" class="hc-btn hc-btn--sec" (click)="respondaPagamento(false)">{{statusEmAcao ? 'Ainda não' : 'Cancelar'}}</button>
      <button type="button" class="hc-btn hc-btn--verde" (click)="respondaPagamento(true)"><i class="fe-check" aria-hidden="true"></i>Sim, recebi</button>
    </div>

    <section class="hc-bloco" *ngIf="escolhendoFormaDoSaldo">
      <button type="button" class="hc-linha" *ngFor="let forma of formasDoSaldo" (click)="respondaPagamento(true, forma)">
        <span class="hc-pastel hc-p-teal"><i class="fe-dollar-sign" aria-hidden="true"></i></span>
        <span class="hc-linha__txt"><b>{{forma.descricao}}</b></span>
      </button>
    </section>
  </div>

  <div class="hc-aviso" *ngIf="aviso" role="status">{{aviso}}</div>
</div>
